import React from 'react';
import { InfoField } from '~/shared/InfoField';
import { useQuery } from '@tanstack/react-query';
import { formatAddress } from '~/util/functions';
import { Section } from '~/shared/section/Section';
import { getPatientAddressesOptions } from '@generated';
import { SectionTitle } from '~/shared/section/SectionTitle';

export function VisitAddress({ stayId }: { stayId: string }) {
	const { data: demographics, isLoading } = useQuery(getPatientAddressesOptions(stayId));

	if (isLoading || !demographics) {
		return null;
	}

	return (
		<Section header={<SectionTitle title="Visit Information" />}>
			<div className="gap-4 p-6">
				<InfoField label="Visit Address" value={formatAddress(demographics.visitAddress)} />
			</div>
		</Section>
	);
}
